import React from "react";

import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";

const impentrablesecurity = require("../../../assets/icons-pack/5.2 Direct Connect/ic_01_impentrablesecurity.svg");
const lowlatency = require("../../../assets/icons-pack/5.2 Direct Connect/ic_02_lowlatency.svg");

const DirectConnect = () => {
    const heading = `DIRECT CONNECT`;
    const details = `High-speed, stable and secure dedicated network connection.`;

    const overview = [
        `Direct Connect is a high-speed, stable, and secure dedicated network connection. It connects your local data center to a Virtual Private Cloud (VPC) on DETASAD Cloud. As DETASAD’s data center is a carrier neutral data center and DETASAD is also a licensed ISP under CITC, hence, you can order any type of link through any DSP. With its low-latency design, Direct Connect maximizes DETASAD’s services and existing IT facilities to build a flexible, scalable hybrid cloud computing environment. `
    ];

    const advantages = [
        [
            `Strong Security`,
            `Utilizing dedicated private connections and isolated networks, Direct Connect guarantees safe access to VPCs on DETASAD Cloud.`,
            impentrablesecurity
        ],
        [
            `Low Latency `,
            `Data is transmitted through the dedicated network, which features high performance and low latency, providing improved user experience and negligible network jitters.`,
            lowlatency
        ],
        [
            `Flexible Access`,
            `You can connect to one or more VPCs from a location that is closer to your premises to ensure that you can access cloud resources at the quickest speed possible.`,
            impentrablesecurity // temp
        ],
        [
            `Multiple Points of Access`,
            `DETASAD’s Direct Connect supports a variety of leased line types to provide you the choose from a set of multiple options.`,
            lowlatency //temp
        ]
    ];

    const functions = [
        [`High Availability Connections`, [`Supports both dedicated and Internet-based connections between on-premise data centers and VPC networks, offering high availability and redundancy.`]],
        [`Smooth Migrations`, [`Supports connectivity between on-premise data centers and VPC networks, enabling smooth migrations.`]],
        [`Secure transmission`, [`All data is transmitted through DETASAD’s facilities, hence avoiding Internet-based connections and reducing the risk of data theft.`]]
    ]
    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} className="bg-network"/>
            <SubNav overview={overview} advantages={advantages} functions={functions}/>
            <Footer />
        </div>
    );
};

export default DirectConnect;
